import React from 'react';

import Link from 'next/link';
import { MdKeyboardBackspace } from 'react-icons/md';

function NavBlog() {
 return (
  <div className=' absolute bg-white w-full flex flex-col md:flex-row  items-center justify-center md:justify-between  md:py-0  gap-4'>
   <div
    className='flex items-center justify-center flex-col w-full g-red-600 text-backbg text-4xl font-poppins
    pt-2 md:pt-0  '
   >
    <p
     className={`text-[8vw] xs:text-[6.5vw] sm:text-[5vw] md:text-[4.5vw]  lg:text-[4vw] xl:text-[3.5vw] bl:text-[3vw] text-backbg  
        navIndexOne   font-poppins-tracking-[3px] md:-tracking-[5px] `}
    >
     JAMIVIZ
    </p>
   </div>
   <div className='flex items-center justify-center  w-full md:py-6 pb-4 g-red-800'>
    <Link
     href={{
      pathname: '/',
     }}
     className={` md:hover:bg-backbg/10  p-2 px-4 text-hp10 text-backbg border-[1px] border-backbg  `}
    >
     <MdKeyboardBackspace className='w-5 h-5 mr-1  pb-1' /> Portfolio
    </Link>
   </div>
  </div>
 );
}

export default NavBlog;
